import { Locale } from 'chaika-enums';
export const entryPage = {
    selectEntryTypeAndAuthor: {
        [Locale.Ru]: 'Выберите тип записи и автора',
        [Locale.Am]: 'Ընտրեք գրառման տեսակը և հեղինակին',
        [Locale.En]: 'Select entry type and author',
        [Locale.Pt]: 'Selecione o tipo de entrada e o autor',
        [Locale.Ge]: 'Select entry type and author',
    },
    linkToBookingLabel: {
        [Locale.Ru]: 'Связь с бронью',
        [Locale.Am]: 'Կապ ամրագրման հետ',
        [Locale.En]: 'Link to reservation',
        [Locale.Pt]: 'Link para reserva',
        [Locale.Ge]: 'კავშირი ჯავშანთან',
    },
    searchPlaceHolder: {
        [Locale.Ru]: 'Введите название, чтобы найти нужный тип записи',
        [Locale.Am]: 'Մուտքագրեք անվանումը՝ անհրաժեշտ գրառման տեսակը գտնելու համար',
        [Locale.En]: 'Enter a name to find the desired record type',
        [Locale.Pt]: 'Digite um nome para encontrar o tipo de registro desejado',
        [Locale.Ge]: 'შეიყვანეთ სახელი, რომ იპოვოთ სასურველი ჩანაწერის ტიპი',
    },
    informedConsentSignedLabel: {
        [Locale.Ru]: 'ИДС подписано',
        [Locale.Am]: 'Տեղեկացված համաձայնությունը ստորագրված է',
        [Locale.En]: 'IDS signed',
        [Locale.Pt]: 'IDS assinado',
        [Locale.Ge]: 'IDS ხელმოწერილი',
    },
    informedConsentNotSignedLabel: {
        [Locale.Ru]: 'ИДС не подписано',
        [Locale.Am]: 'Տեղեկացված համաձայնությունը ստորագրված չէ',
        [Locale.En]: 'IDS not signed',
        [Locale.Pt]: 'IDS não assinado',
        [Locale.Ge]: 'პირადობის მოწმობა არ არის ხელმოწერილი',
    },
    hasEDS: {
        [Locale.Ru]: 'Подписано с помощью ЭЦП',
        [Locale.Am]: 'Ստորագրված է էլեկտրոնային ստորագրությամբ',
        [Locale.En]: 'Signed with EDS',
        [Locale.Pt]: 'Assinado com EDS',
        [Locale.Ge]: 'ხელმოწერილი EDS-ით',
    },
    signedEDS: {
        [Locale.Ru]: 'Подписано ЭЦП',
        [Locale.Am]: 'Ստորագրված է էլեկտրոնային ստորագրությամբ',
        [Locale.En]: 'Signed with EDS',
        [Locale.Pt]: 'Assinado com EDS',
        [Locale.Ge]: 'ხელმოწერილია ციფრული ხელმოწერით',
    },
    sendContactsButtonLabel: {
        [Locale.Ru]: 'Запрос чата',
        [Locale.Am]: 'Չաթի հարցում',
        [Locale.En]: 'Chat request',
        [Locale.Pt]: 'Solicitação de bate-papo',
        [Locale.Ge]: 'Chat request',
    },
    noPatientChatCheckTitle: {
        [Locale.Ru]: 'У вас нет чата с пациентом',
        [Locale.Am]: 'Դուք չաթ չունեք պացիենտի հետ',
        [Locale.En]: 'You have no chat with the patient',
        [Locale.Pt]: 'Você não tem chat com o paciente',
        [Locale.Ge]: 'You have no chat with the patient',
    },
    noPatientChatCheckDescription: {
        [Locale.Ru]: 'Отправьте запрос на создание чата, чтобы поддерживать контакт после окончания приёма',
        [Locale.Am]: 'Ուղարկեք չաթ ստեղծելու հարցում՝ ընդունելության ավարտից հետո կապը պահպանելու համար',
        [Locale.En]: 'Send a chat creation request to stay in touch after the appointment',
        [Locale.Pt]: 'Envie uma solicitação de criação de chat para manter contato após a consulta',
        [Locale.Ge]: 'Send a chat creation request to stay in touch after the appointment',
    },
    createChatWithPractice: {
        [Locale.Ru]: 'Создать чат с практикой',
        [Locale.Am]: 'Ստեղծել չաթ պրակտիկայի հետ',
        [Locale.En]: 'Create chat with practice',
        [Locale.Ge]: 'Create chat with practice',
        [Locale.Pt]: 'Crie um chat com prática',
    },
    chatWithPracticeIsBeingCreated: {
        [Locale.Ru]: 'Чат с практикой создается...',
        [Locale.Am]: 'Պրակտիկայի հետ չաթը ստեղծվում է...',
        [Locale.En]: 'Chat with practice is being created...',
        [Locale.Ge]: 'Chat with practice is being created...',
        [Locale.Pt]: 'Está a ser criado um chat com suporte prático...',
    },
    createChatWithAssistants: {
        [Locale.Ru]: 'Создать чат с ассистентами',
        [Locale.Am]: 'Ստեղծել չաթ օգնականների հետ',
        [Locale.Pt]: 'Criar um chat com assistentes',
        [Locale.En]: 'Create chat with assitants',
        [Locale.Ge]: 'Create chat with assitants',
    },
    chatWithAssistantsIsBeingCreated: {
        [Locale.Ru]: 'Чат с ассистентами создается...',
        [Locale.Am]: 'Օգնականների հետ չաթը ստեղծվում է...',
        [Locale.En]: 'Chat with assitants is being created...',
        [Locale.Ge]: 'Chat with assitants is being created...',
        [Locale.Pt]: 'Está a ser criado um chat com assistentes...',
    },
    createChatWithDoctor: {
        [Locale.Ru]: 'Создать чат с доктором',
        [Locale.Am]: 'Ստեղծել չաթ բժշկի հետ',
        [Locale.Pt]: 'Iniciar um chat com um médico',
        [Locale.En]: 'Create chat with doctor',
        [Locale.Ge]: 'Create chat with doctor',
    },
    сhatWithDoctorIsBeingCreated: {
        [Locale.Ru]: 'Чат с доктором создается...',
        [Locale.Am]: 'Բժշկի հետ չաթը ստեղծվում է...',
        [Locale.En]: 'Chat with doctor is being created...',
        [Locale.Ge]: 'Chat with doctor is being created...',
        [Locale.Pt]: 'Crie um gráfico com o médico',
    },
    createTopicWithPractice: {
        [Locale.Ru]: 'Создать топик с практикой',
        [Locale.Am]: 'Ստեղծել թոփիկ պրակտիկայի հետ',
        [Locale.En]: 'Create topic with practice',
        [Locale.Pt]: 'Crie um tópico com prática',
        [Locale.Ge]: 'Create topic with practice',
    },
    createTopicWithDoctor: {
        [Locale.Ru]: 'Создать топик с доктором',
        [Locale.Am]: 'Ստեղծել թոփիկ բժշկի հետ',
        [Locale.En]: 'Create topic with doctor',
        [Locale.Pt]: 'Criar tópico com médico',
        [Locale.Ge]: 'Create topic with doctor',
    },
    noPracticeWithTgLink: {
        [Locale.Ru]: 'Практика с ссылкой на телеграм не найдена',
        [Locale.Am]: 'Թելեգրամի հղումով պրակտիկա չի գտնվել',
        [Locale.En]: 'No practice with telegram link was found',
        [Locale.Pt]: 'Nenhuma prática com link de telegrama foi encontrada',
        [Locale.Ge]: 'No practice with telegram link was found',
    },
    patientAlreadyHasSubscription: {
        [Locale.Ru]: 'У пациента уже есть подписка',
        [Locale.Am]: 'Պացիենտն արդեն ունի բաժանորդագրություն',
        [Locale.Pt]: 'O paciente já tem uma assinatura.',
        [Locale.En]: 'Patient already has subscripttion',
        [Locale.Ge]: 'Patient already has subscripttion',
    },
    $patientAlreadyHasDoctorSubscriptionConfirm: {
        [Locale.Ru]: "У пациента уже есть подписка на доктора, '$doctorName'.\nСоздать чат с пациентом?",
        [Locale.Am]: "Պացիենտն արդեն ունի բաժանորդագրություն '$doctorName' բժշկին։\nՍտեղծե՞լ չաթ պացիենտի հետ",
        [Locale.En]: "Patient already has a subscription to doctor '$doctorName'.\nCreate a chat with the patient?",
        [Locale.Pt]: "O paciente já tem uma assinatura para o médico '$doctorName'.\nCriar um chat com o paciente?",
        [Locale.Ge]: "Patient already has a subscription to doctor '$doctorName'.\nCreate a chat with the patient?",
    },
    patientAlreadyHasDoctorSubscriptionConfirmAnonymous: {
        [Locale.Ru]: 'У пациента уже есть подписка на доктора.\nСоздать чат с пациентом?',
        [Locale.Am]: 'Պացիենտն արդեն ունի բժշկի բաժանորդագրություն։\nՍտեղծե՞լ չաթ պացիենտի հետ',
        [Locale.En]: 'Patient already has a subscription to a doctor.\nCreate a chat with the patient?',
        [Locale.Pt]: 'O paciente já tem uma assinatura para um médico.\nCriar um chat com o paciente?',
        [Locale.Ge]: 'Patient already has a subscription to a doctor.\nCreate a chat with the patient?',
    },
    noteTitle: {
        [Locale.Ru]: 'Заметки',
        [Locale.Am]: 'Նշումներ',
        [Locale.En]: 'Notes',
        [Locale.Pt]: 'Notas',
        [Locale.Ge]: 'შენიშვნები',
    },
    transcriptionTitle: {
        [Locale.Ru]: 'Расшифровка',
        [Locale.Am]: 'Վերծանում',
        [Locale.En]: 'Transcription',
        [Locale.Pt]: 'Transcrição',
        [Locale.Ge]: 'ტრანსკრიფცია',
    },
    translateLanguage: {
        [Locale.Ru]: 'Язык перевода',
        [Locale.Am]: 'Թարգմանության լեզու',
        [Locale.En]: 'Translation language',
        [Locale.Pt]: 'Idioma de tradução',
        [Locale.Ge]: 'მთარგმნელობითი ენა',
    },
    noteCaption: {
        [Locale.Ru]: 'Видны только вам',
        [Locale.Am]: 'Տեսանելի են միայն ձեզ',
        [Locale.En]: 'Visible only to you',
        [Locale.Pt]: 'Visível apenas para você',
        [Locale.Ge]: 'მხოლოდ შენთვის ჩანს',
    },
    voiceRecord: {
        [Locale.Ru]: 'Запись голоса',
        [Locale.Am]: 'Ձայնագրություն',
        [Locale.En]: 'Voice record',
        [Locale.Pt]: 'Gravação de voz',
        [Locale.Ge]: 'გამოცდილება',
    },
    fileAnalysis: {
        [Locale.Ru]: 'Анализ файлов',
        [Locale.Am]: 'Ֆայլերի վերլուծություն',
        [Locale.En]: 'File analysis',
        [Locale.Pt]: 'Análise de arquivo',
        [Locale.Ge]: 'ფაილის ანაზღაურება',
    },
    ehrAnalysis: {
        [Locale.Ru]: 'Анализ медкарты',
        [Locale.Am]: 'Բժշկական քարտի վերլուծություն',
        [Locale.En]: 'Ehr analysis',
        [Locale.Pt]: 'Análise Ehr',
        [Locale.Ge]: 'მედიკის ანაზღაურება',
    },
    approvalTitle: {
        [Locale.Ru]: 'Согласование СК',
        [Locale.Am]: 'Ապահովագրական ընկերության համաձայնեցում',
        [Locale.En]: 'Approval Insurance Company',
        [Locale.Pt]: 'Companhia de Seguros de Aprovação',
        [Locale.Ge]: 'დამტკიცების სადაზღვევო კომპანია',
    },
    approvalOfAssignedServicesWithTheCompany: {
        [Locale.Ru]: 'Согласование назначенных услуг с СК',
        [Locale.Am]: 'Նշանակված ծառայությունների համաձայնեցում ապահովագրական ընկերության հետ',
        [Locale.En]: 'Approval of assigned services with the company',
        [Locale.Pt]: 'Aprovação dos serviços atribuídos junto à empresa',
        [Locale.Ge]: 'დამტკიცების სადაზღვევო კომპანია',
    },
    templateTitle: {
        [Locale.Ru]: 'Быстрое заполнение',
        [Locale.Am]: 'Արագ լրացում',
        [Locale.En]: 'Quick Fill',
        [Locale.Pt]: 'Preenchimento rápido',
        [Locale.Ge]: 'სწრაფი შევსება',
    },
    filesAndLinksTitle: {
        [Locale.Ru]: 'Файлы и ссылки',
        [Locale.Am]: 'Ֆայլեր և հղումներ',
        [Locale.En]: 'Files and links',
        [Locale.Pt]: 'Arquivos e links',
        [Locale.Ge]: 'ფაილები და ბმულები',
    },
    templateSingleTabLabel: {
        [Locale.Ru]: 'Одно поле',
        [Locale.Am]: 'Մեկ դաշտ',
        [Locale.En]: 'One field',
        [Locale.Pt]: 'Um campo',
        [Locale.Ge]: 'ერთი ველი',
    },
    templateMultipleTabLabel: {
        [Locale.Ru]: 'Группа полей',
        [Locale.Am]: 'Դաշտերի խումբ',
        [Locale.En]: 'Field group',
        [Locale.Pt]: 'Grupo de Campo',
        [Locale.Ge]: 'ველების ჯგუფი',
    },
    noTemplatesTitle: {
        [Locale.Ru]: 'Создавайте шаблоны заполнения полей, чтобы уделить больше внимания пациенту, а не тратить время на заполнение карты',
        [Locale.Am]: 'Ստեղծեք դաշտերի լրացման ձևանմուշներ՝ պացիենտին ավելի շատ ուշադրություն դարձնելու և քարտի լրացման վրա ժամանակ չկորցնելու համար',
        [Locale.En]: 'Create templates for filling in fields to pay more attention to the patient, and not waste time filling out the card',
        [Locale.Pt]: 'Crie modelos de preenchimento de campos para dar mais atenção ao paciente e não perder tempo preenchendo o cartão',
        [Locale.Ge]: 'შექმენით შაბლონები ველების შესავსებად, რომ მეტი ყურადღება მიაქციოთ პაციენტს და არ დაკარგოთ დრო ბარათის შევსებაში',
    },
    templateButtonCreateLabel: {
        [Locale.Ru]: 'Создать шаблон',
        [Locale.Am]: 'Ստեղծել ձևանմուշ',
        [Locale.En]: 'Create a template',
        [Locale.Pt]: 'Crie um modelo',
        [Locale.Ge]: 'შექმნა თარგი',
    },
    templateButtonCreateFromEntryLabel: {
        [Locale.Ru]: 'Создать из заполненной записи',
        [Locale.Am]: 'Ստեղծել լրացված գրառումից',
        [Locale.En]: 'Create from the filled entry',
        [Locale.Pt]: 'Criar a partir do registro preenchido',
        [Locale.Ge]: 'შექმნა შევსებული ჩანაწერიდან',
    },
    templateCreateFromEntryError: {
        [Locale.Ru]: 'Не удалось создать шаблон',
        [Locale.Am]: 'Չհաջողվեց ստեղծել ձևանմուշը',
        [Locale.En]: 'Failed to create the template',
        [Locale.Pt]: 'Não foi possível criar o modelo',
        [Locale.Ge]: 'თარგის შექმნა ვერ მოხერხდა',
    },
    historyFieldTitle: {
        [Locale.Ru]: 'Выберите поле',
        [Locale.Am]: 'Ընտրեք դաշտը',
        [Locale.En]: 'Select a field',
        [Locale.Pt]: 'Selecione um campo',
        [Locale.Ge]: 'აირჩიეთ ველი',
    },
    showOnlyMyHistory: {
        [Locale.Ru]: 'Показать только мои',
        [Locale.Am]: 'Ցուցադրել միայն իմերը',
        [Locale.En]: 'Show only mine',
        [Locale.Pt]: 'Mostrar apenas os meus',
        [Locale.Ge]: 'Show only mine',
    },
    showAllHistory: {
        [Locale.Ru]: 'Показать всю историю',
        [Locale.Am]: 'Ցուցադրել ամբողջ պատմությունը',
        [Locale.En]: 'Show all history',
        [Locale.Pt]: 'Mostrar todo o histórico',
        [Locale.Ge]: 'Show all history',
    },
    createTemplateTitle: {
        [Locale.Ru]: 'Новый шаблон',
        [Locale.Am]: 'Նոր ձևանմուշ',
        [Locale.En]: 'New Template',
        [Locale.Pt]: 'Novo modelo',
        [Locale.Ge]: 'ახალი თარგი',
    },
    createTemplateTextFieldTitle: {
        [Locale.Ru]: 'Текст в поле',
        [Locale.Am]: 'Տեքստը դաշտում',
        [Locale.En]: 'Text in the field',
        [Locale.Pt]: 'Texto, não campo',
        [Locale.Ge]: 'ტექსტი სფეროში',
    },
    createTemplateGroupPlaceholder: {
        [Locale.Ru]: 'Введите название группы',
        [Locale.Am]: 'Մուտքագրեք խմբի անվանումը',
        [Locale.En]: 'Enter the name of the group',
        [Locale.Pt]: 'Digite o nome do grupo',
        [Locale.Ge]: 'შეიყვანეთ ჯგუფის სახელი',
    },
    createTemplateCreateSubgroup: {
        [Locale.Ru]: 'Сделать подгруппой',
        [Locale.Am]: 'Դարձնել ենթախումբ',
        [Locale.En]: 'Make a subgroup',
        [Locale.Pt]: 'Faça um subgrupo',
        [Locale.Ge]: 'გააკეთეთ ქვეჯგუფი',
    },
    createTemplateFromNextTitle: {
        [Locale.Ru]: 'Расположить в следующей группе',
        [Locale.Am]: 'Տեղադրել հաջորդ խմբում',
        [Locale.En]: 'Place in the next group',
        [Locale.Pt]: 'Não coloque o próximo grupo',
        [Locale.Ge]: 'ადგილი შემდეგ ჯგუფში',
    },
    createTemplateFromNextPlaceholder: {
        [Locale.Ru]: 'Выбрать из списка',
        [Locale.Am]: 'Ընտրել ցանկից',
        [Locale.En]: 'Select from the list',
        [Locale.Pt]: 'Selecione na lista',
        [Locale.Ge]: 'აირჩიეთ სიიდან',
    },
    groupTemplateFormNewTemplate: {
        [Locale.Ru]: 'Новый шаблон для группы полей',
        [Locale.Am]: 'Նոր ձևանմուշ դաշտերի խմբի համար',
        [Locale.En]: 'New template for a group of fields',
        [Locale.Pt]: 'Novo modelo para um grupo de campos',
        [Locale.Ge]: 'ახალი შაბლონი ველების ჯგუფისთვის',
    },
    groupTemplateFormEditTemplate: {
        [Locale.Ru]: 'Редактирование шаблона для группы полей',
        [Locale.Am]: 'Դաշտերի խմբի ձևանմուշի խմբագրում',
        [Locale.En]: 'Editing a template for a group of fields',
        [Locale.Pt]: 'Editando um modelo para um grupo de campos',
        [Locale.Ge]: 'რედაქტირება თარგი ჯგუფის სფეროებში',
    },
    groupTemplateTextFieldTitle: {
        [Locale.Ru]: 'Текст в поле',
        [Locale.Am]: 'Տեքստը դաշտից',
        [Locale.En]: 'Text from field',
        [Locale.Pt]: 'Texto do campo',
        [Locale.Ge]: 'ტექსტი სფეროში',
    },
    groupTemplateFormTemplateName: {
        [Locale.Ru]: 'Название шаблона',
        [Locale.Am]: 'Ձևանմուշի անվանում',
        [Locale.En]: 'Template name',
        [Locale.Pt]: 'Nome do modelo',
        [Locale.Ge]: 'თარგის სახელი',
    },
    groupTemplateFormAddField: {
        [Locale.Ru]: 'Добавить поле',
        [Locale.Am]: 'Ավելացնել դաշտ',
        [Locale.En]: 'Add Field',
        [Locale.Pt]: 'Adicionar campo',
        [Locale.Ge]: 'დაამატეთ ველი',
    },
    groupTemplateFormButtonRemove: {
        [Locale.Ru]: 'Удалить шаблон',
        [Locale.Am]: 'Ջնջել ձևանմուշը',
        [Locale.En]: 'Delete Template',
        [Locale.Pt]: 'Excluir modelo',
        [Locale.Ge]: 'წაშლა თარგი',
    },
    groupFieldFormTitle: {
        [Locale.Ru]: 'Шаблон для поля',
        [Locale.Am]: 'Ձևանմուշ դաշտի համար',
        [Locale.En]: 'Template for a field',
        [Locale.Pt]: 'Modelo para um campo',
        [Locale.Ge]: 'თარგი სფეროში',
    },
    groupFieldFormTitleSecondPart: {
        [Locale.Ru]: 'удален',
        [Locale.Am]: 'ջնջված է',
        [Locale.En]: 'deleted',
        [Locale.Pt]: 'excluído',
        [Locale.Ge]: 'წაშლილი',
    },
    sendIC: {
        [Locale.Ru]: 'Отправить ИДС',
        [Locale.Am]: 'Ուղարկել տեղեկացված համաձայնությունը',
        [Locale.En]: 'Send IC',
        [Locale.Pt]: 'Enviar CI',
        [Locale.Ge]: 'პირადი პირადობის მოწმობა',
    },
    printIC: {
        [Locale.Ru]: 'Распечатать ИДС',
        [Locale.Am]: 'Տպել տեղեկացված համաձայնությունը',
        [Locale.En]: 'Print IC',
        [Locale.Pt]: 'Imprimir CI',
        [Locale.Ge]: 'ბეჭდვითი პირადობის მოწმობები',
    },
    editICForServices: {
        [Locale.Ru]: 'Редактировать ИДС для услуг',
        [Locale.Am]: 'Խմբագրել ծառայությունների տեղեկացված համաձայնությունը',
        [Locale.En]: 'Edit IC for services',
        [Locale.Pt]: 'Editar CI para serviços',
        [Locale.Ge]: 'Edit IC for services',
    },
    createICForServices: {
        [Locale.Ru]: 'Создать ИДС для услуг',
        [Locale.Am]: 'Ստեղծել ծառայությունների տեղեկացված համաձայնություն',
        [Locale.En]: 'Create IC for services',
        [Locale.Pt]: 'Criar CI para serviços',
        [Locale.Ge]: 'Create IC for services',
    },
    editICForPatients: {
        [Locale.Ru]: 'Редактировать ИДС для пациентов',
        [Locale.Am]: 'Խմբագրել պացիենտների տեղեկացված համաձայնությունը',
        [Locale.En]: 'Edit IC for patients',
        [Locale.Pt]: 'Editar CI para pacientes',
        [Locale.Ge]: 'Edit IC for patients',
    },
    createICForPatients: {
        [Locale.Ru]: 'Создать ИДС для пациентов',
        [Locale.Am]: 'Ստեղծել պացիենտների տեղեկացված համաձայնություն',
        [Locale.En]: 'Create IC for patients',
        [Locale.Pt]: 'Criar CI para pacientes',
        [Locale.Ge]: 'Create IC for patients',
    },
    translationEntry: {
        [Locale.Ru]: 'Перевод записи',
        [Locale.Am]: 'Գրառման թարգմանություն',
        [Locale.En]: 'Translate entry',
        [Locale.Pt]: 'Traduzir entrada',
        [Locale.Ge]: 'თარგმნა შესვლის',
    },
    translationField: {
        [Locale.Ru]: 'Перевод поля',
        [Locale.Am]: 'Դաշտի թարգմանություն',
        [Locale.En]: 'Translate field',
        [Locale.Pt]: 'Campo de tradução',
        [Locale.Ge]: 'თარგმნა ველის',
    },
    fillingHistory: {
        [Locale.Ru]: 'История заполнения',
        [Locale.Am]: 'Լրացման պատմություն',
        [Locale.En]: 'Filling history',
        [Locale.Pt]: 'Preenchendo histórico',
        [Locale.Ge]: 'ისტორიის შევსება',
    },
    showNoEpisodePopupTitle: {
        [Locale.Ru]: 'Добавьте эпизод',
        [Locale.Am]: 'Ավելացրեք էպիզոդ',
        [Locale.En]: 'Add an episode',
        [Locale.Pt]: 'Adicionar um episódio',
        [Locale.Ge]: 'ეპიზოდის დამატება',
    },
    showNoReferralsPopupTitle: {
        [Locale.Ru]: 'Добавьте направления',
        [Locale.Am]: 'Ավելացրեք ուղեգրեր',
        [Locale.En]: 'Add referrals',
        [Locale.Pt]: 'Adicionar referências',
        [Locale.Ge]: 'დაამატეთ მიმართულებები',
    },
    showNoTasksPopupTitle: {
        [Locale.Ru]: 'Добавьте задания',
        [Locale.Am]: 'Ավելացրեք առաջադրանքներ',
        [Locale.En]: 'Add tasks',
        [Locale.Pt]: 'Adicionar tarefas',
        [Locale.Ge]: 'დავალებების დამატება',
    },
    showNoRenderedServicesPopupTitle: {
        [Locale.Ru]: 'Добавьте услугу',
        [Locale.Am]: 'Ավելացրեք ծառայություն',
        [Locale.En]: 'Add a rendered service',
        [Locale.Pt]: 'Adicione um serviço prestado',
        [Locale.Ge]: 'სერვისის დამატება',
    },
    showNoMedicalCasesPopupDescription: {
        [Locale.Ru]: 'Нельзя опубликовать запись, если для неё не выбран ни один эпизод',
        [Locale.Am]: 'Հնարավոր չէ հրապարակել գրառումը, եթե դրա համար ընտրված չէ ոչ մի էպիզոդ',
        [Locale.En]: 'You cannot опубликовать a record if no episode is selected for it',
        [Locale.Pt]: 'Você não pode reproduzir um registro se nenhum episódio estiver selecionado para ele',
        [Locale.Ge]: 'თქვენ არ შეგიძლიათ გამოაქვეყნოთ ჩანაწერი, თუ არ არის შერჩეული ეპიზოდი',
    },
    showNoDiagnosesPopupDescription: {
        [Locale.Ru]: 'Нельзя опубликовать запись, если для неё не добавлены диагнозы',
        [Locale.Am]: 'Հնարավոր չէ հրապարակել գրառումը, եթե դրա համար ավելացված չեն ախտորոշումներ',
        [Locale.En]: 'It is not possible to publish the entry if diagnoses are not added for it',
        [Locale.Pt]: 'Não é possível publicar o verbete se não forem adicionados diagnósticos para ele',
        [Locale.Ge]: 'თქვენ არ შეგიძლიათ გამოაქვეყნოთ ჩანაწერი, თუ მას დიაგნოზი არ დაემატა.',
    },
    hasRenderedServicesDescription: {
        [Locale.Ru]: 'В запись не добавлены услуги.\nВы действительно хотите опубликовать запись?',
        [Locale.Am]: 'Գրառմանը ծառայություններ ավելացված չեն։\nԻսկապե՞ս ուզում եք հրապարակել գրառումը',
        [Locale.En]: 'No services have been added to the record.\nDo you really want to publish the record?',
        [Locale.Pt]: 'Nenhum serviço foi adicionado ao registro.\\nDeseja realmente publicar o registro?',
        [Locale.Ge]: 'ჩანაწერს არანაირი სერვისი არ დაემატა.\nნამდვილად გსურთ ჩანაწერის გამოქვეყნება?',
    },
    showNoReferralsPopupDescription: {
        [Locale.Ru]: 'Вы не назначили ни одного направления для пациента. Без них пациенту будет сложнее спланировать лечение, а вам отслеживать его состояние.',
        [Locale.Am]: 'Դուք պացիենտի համար ոչ մի ուղեգիր չեք նշանակել։ Առանց դրանց պացիենտին ավելի դժվար կլինի պլանավորել բուժումը, իսկ ձեզ՝ հետևել նրա վիճակին։',
        [Locale.En]: `You have to assign some referrals for patient. It will be easier for you and a patient to track patient's health state and treatment plan.`,
        [Locale.Pt]: `Você precisa atribuir alguns encaminhamentos ao paciente. Assim, será mais fácil para você e para o paciente acompanhar o estado de saúde e o plano de tratamento.`,
        [Locale.Ge]: 'პაციენტისთვის ერთი რეფერალი არ დაგინიშნავთ. მათ გარეშე პაციენტს უფრო გაუჭირდება მკურნალობის დაგეგმვა და თქვენთვის მისი მდგომარეობის მონიტორინგი.',
    },
    showNoTasksPopupDescription: {
        [Locale.Ru]: 'Вы не добавили ни одного задания. Без них будет сложнее отслеживать состояние эпизода.',
        [Locale.Am]: 'Դուք ոչ մի առաջադրանք չեք ավելացրել։ Առանց դրանց ավելի դժվար կլինի հետևել էպիզոդի վիճակին։',
        [Locale.En]: `You have to assign some tasks for patient. It will be easier for you and a patient to track patient's health state and treatment plan.`,
        [Locale.Pt]: `Você precisa atribuir algumas tarefas ao paciente. Assim, será mais fácil para você e para o paciente acompanhar o estado de saúde e o plano de tratamento.`,
        [Locale.Ge]: 'თქვენ უნდა დაავალოს გარკვეული ამოცანები პაციენტი. თქვენთვის და პაციენტისთვის უფრო ადვილი იქნება პაციენტის ჯანმრთელობის მდგომარეობისა და მკურნალობის გეგმის თვალყურის დევნება.',
    },
    hasRenderedServicesConfirm: {
        [Locale.Ru]: 'Да, опубликовать',
        [Locale.Am]: 'Այո, հրապարակել',
        [Locale.En]: 'Yes, publish',
        [Locale.Pt]: 'Sim, publicar',
        [Locale.Ge]: 'დიახ, გამოაქვეყნეთ',
    },
    confirmWithoutReferrals: {
        [Locale.Ru]: 'Продолжить без направлений',
        [Locale.Am]: 'Շարունակել առանց ուղեգրերի',
        [Locale.En]: 'Continue without referrals',
        [Locale.Pt]: 'Continuar sem referências',
        [Locale.Ge]: 'გაგრძელება მიმართულებების გარეშე',
    },
    confirmWithoutTasks: {
        [Locale.Ru]: 'Продолжить без заданий',
        [Locale.Am]: 'Շարունակել առանց առաջադրանքների',
        [Locale.En]: 'Continue without tasks',
        [Locale.Pt]: 'Continuar sem tarefas',
        [Locale.Ge]: 'გაგრძელება ამოცანების გარეშე',
    },
    returnToEntry: {
        [Locale.Ru]: 'Вернуться к записи',
        [Locale.Am]: 'Վերադառնալ գրառմանը',
        [Locale.En]: 'Back to recording',
        [Locale.Pt]: 'Voltar à gravação',
        [Locale.Ge]: 'დაბრუნდი ჩაწერაზე',
    },
    withoutReservationLabel: {
        [Locale.Ru]: 'Без брони',
        [Locale.Am]: 'Առանց ամրագրման',
        [Locale.En]: 'Without reservation',
        [Locale.Pt]: 'Sem reserva',
        [Locale.Ge]: 'ჯავშნის გარეშე',
    },
    fieldsFromEntry: {
        [Locale.Ru]: 'Поля в записи',
        [Locale.Am]: 'Դաշտերը գրառման մեջ',
        [Locale.En]: 'Fields from entry',
        [Locale.Pt]: 'Campos de entrada',
        [Locale.Ge]: 'ველები ჩანაწერში',
    },
    editTemplates: {
        [Locale.Ru]: 'Редактирование шаблонов',
        [Locale.Am]: 'Ձևանմուշների խմբագրում',
        [Locale.En]: 'Edit templates',
        [Locale.Pt]: 'Editar modelos',
        [Locale.Ge]: 'შაბლონების რედაქტირება',
    },
    allTemplates: {
        [Locale.Ru]: 'Все шаблоны',
        [Locale.Am]: 'Բոլոր ձևանմուշները',
        [Locale.En]: 'All templates',
        [Locale.Pt]: 'Todos os modelos',
        [Locale.Ge]: 'ყველა თარგები',
    },
    clickOnTitleForEdit: {
        [Locale.Ru]: 'Кликните на название, чтобы редактировать',
        [Locale.Am]: 'Սեղմեք անվանման վրա՝ խմբագրելու համար',
        [Locale.En]: 'Click on title for edit',
        [Locale.Pt]: 'Clique no título para editar',
        [Locale.Ge]: 'დაწკაპეთ სათაური რედაქტირება',
    },
    chooseFiles: {
        [Locale.Ru]: 'Выберите файлы',
        [Locale.Am]: 'Ընտրեք ֆայլերը',
        [Locale.En]: 'Select Files',
        [Locale.Pt]: 'Selecione arquivos',
        [Locale.Ge]: 'აირჩიეთ ფაილები',
    },
    chooseFilesPartTwo: {
        [Locale.Ru]: 'или просто перетащите их в это поле',
        [Locale.Am]: 'կամ պարզապես քաշեք դրանք այս դաշտ',
        [Locale.En]: 'or just drag and drop them into this field',
        [Locale.Pt]: 'ou apenas arraste e solte-os neste campo',
        [Locale.Ge]: 'ან უბრალოდ გადაიტანეთ ისინი ამ სფეროში',
    },
    serviceInformedConsentTitle: {
        [Locale.Ru]: 'ИДС для услуг',
        [Locale.Am]: 'Ծառայությունների տեղեկացված համաձայնություն',
        [Locale.En]: `Rendered services`,
        [Locale.Pt]: 'Termos de consentimento dos serviços prestados',
        [Locale.Ge]: 'ინფორმირებული ნებაყოფლობითი თანხმობა მომსახურება',
    },
    serviceInformedConsentUploadTitle: {
        [Locale.Ru]: 'Добавление ИДС для услуги:',
        [Locale.Am]: 'Ծառայության տեղեկացված համաձայնության ավելացում՝',
        [Locale.En]: `Upload IC for service:`,
        [Locale.Pt]: 'Carregar IC para serviço:',
        [Locale.Ge]: 'სამსახურში ინფორმირებული ნებაყოფლობითი თანხმობის დამატება:',
    },
    serviceInformedConsentUpload: {
        [Locale.Ru]: 'Добавить',
        [Locale.Am]: 'Ավելացնել',
        [Locale.En]: 'Upload',
        [Locale.Pt]: 'Enviar',
        [Locale.Ge]: 'დამატება',
    },
    serviceInformedConsentPreview: {
        [Locale.Ru]: 'Просмотреть',
        [Locale.Am]: 'Դիտել',
        [Locale.En]: 'Preview',
        [Locale.Pt]: 'Visualização',
        [Locale.Ge]: 'იხილე',
    },
    serviceInformedConsentArchive: {
        [Locale.Ru]: 'Удалить',
        [Locale.Am]: 'Ջնջել',
        [Locale.En]: 'Delete',
        [Locale.Pt]: 'Excluir',
        [Locale.Ge]: 'ამოღება',
    },
    showEverywhere: {
        [Locale.Ru]: 'Показывать везде',
        [Locale.Am]: 'Ցուցադրել ամենուր',
        [Locale.En]: 'Show everywhere',
        [Locale.Pt]: 'Mostrar em todos os lugares',
        [Locale.Ge]: 'Show everywhere',
    },
    hideFromPatient: {
        [Locale.Ru]: 'Не показывать пациенту',
        [Locale.Am]: 'Չցուցադրել պացիենտին',
        [Locale.En]: 'Do not show to patient',
        [Locale.Pt]: 'Não mostre ao paciente',
        [Locale.Ge]: 'Do not show to patient',
    },
    alreadyLeftEntry: {
        [Locale.Ru]: 'Вы уже оставляли запись в карте данного пациента сегодня. Создать новую запись?',
        [Locale.Am]: 'Դուք այսօր արդեն գրառում եք թողել այս պացիենտի քարտում։ Ստեղծե՞լ նոր գրառում',
        [Locale.En]: `You have already left an entry in this patient\'s chart today. Create a new entry?`,
        [Locale.Pt]: 'Você já deixou um registro no prontuário deste paciente hoje. Criar um novo registro?',
        [Locale.Ge]: `You have already left an entry in this patient\'s chart today. Create a new entry?`,
    },
    alreadyLeftEntries: {
        [Locale.Ru]: 'Вы уже оставляли записи в карте данного пациента сегодня. Создать новую запись?',
        [Locale.Am]: 'Դուք այսօր արդեն գրառումներ եք թողել այս պացիենտի քարտում։ Ստեղծե՞լ նոր գրառում',
        [Locale.En]: `You have already left an entries in this patient\'s chart today. Create a new entry?`,
        [Locale.Pt]: 'Você já deixou registros no prontuário deste paciente hoje. Criar um novo registro?',
        [Locale.Ge]: `You have already left an entries in this patient\'s chart today. Create a new entry?`,
    },
    goToEntry: {
        [Locale.Ru]: 'Перейти в запись',
        [Locale.Am]: 'Անցնել գրառմանը',
        [Locale.En]: 'Go to entry',
        [Locale.Pt]: 'Vá para a entrada',
        [Locale.Ge]: 'Go to entry',
    },
    errorOnCreate: {
        [Locale.Ru]: 'Ошибка при создании записи',
        [Locale.Am]: 'Գրառման ստեղծման սխալ',
        [Locale.En]: 'Error creating entry',
        [Locale.Pt]: 'Erro ao criar entrada',
        [Locale.Ge]: 'Error creating entry',
    },
    noLongerTaking: {
        [Locale.Ru]: 'Больше не принимает',
        [Locale.Am]: 'Այլևս չի ընդունում',
        [Locale.En]: 'No longer taking',
        [Locale.Pt]: 'Não tomo mais',
        [Locale.Ge]: 'No longer taking',
    },
    cancelAppointment: {
        [Locale.Ru]: 'Отменить назначение',
        [Locale.Am]: 'Չեղարկել նշանակումը',
        [Locale.En]: 'Cancel appointment',
        [Locale.Pt]: 'Cancelar consulta',
        [Locale.Ge]: 'Cancel appointment',
    },
    appointmentIsCanceled: {
        [Locale.Ru]: 'Назначение отменно',
        [Locale.Am]: 'Նշանակումը չեղարկված է',
        [Locale.En]: 'Appointment is canceled',
        [Locale.Pt]: 'O compromisso foi cancelado',
        [Locale.Ge]: 'Appointment is canceled',
    },
    indicateTheReasonForDiscontinuingTheMedication: {
        [Locale.Ru]: 'Укажите причину отмены медикамента',
        [Locale.Am]: 'Նշեք դեղամիջոցի չեղարկման պատճառը',
        [Locale.En]: 'Please indicate the reason for discontinuing the medication.',
        [Locale.Pt]: 'Indique o motivo da suspensão da medicação.',
        [Locale.Ge]: 'Please indicate the reason for discontinuing the medication.',
    },
    endOfMedicationIntake: {
        [Locale.Ru]: 'Окончание приёма медикамента',
        [Locale.Am]: 'Դեղամիջոցի ընդունման ավարտ',
        [Locale.En]: 'End of medication intake',
        [Locale.Pt]: 'Fim da ingestão de medicamentos',
        [Locale.Ge]: 'End of medication intake',
    },
    selectSubEntryType: {
        [Locale.Ru]: `Выберите тип вложенной записи`,
        [Locale.Am]: `Ընտրեք ներդրված գրառման տեսակը`,
        [Locale.En]: `Select Sub Entry Type`,
        [Locale.Pt]: 'Selecione o tipo de subentrada',
        [Locale.Ge]: `Select Sub Entry Type`,
    },
    selectService: {
        [Locale.Ru]: `Выберите услугу`,
        [Locale.Am]: `Ընտրեք ծառայությունը`,
        [Locale.En]: `Select a service`,
        [Locale.Pt]: 'Selecione um serviço',
        [Locale.Ge]: `Select a service`,
    },
    errorOnSendIDS: {
        [Locale.Ru]: `Возникла ошибка при отправке ИДС`,
        [Locale.Am]: `Տեղեկացված համաձայնությունն ուղարկելիս առաջացել է սխալ`,
        [Locale.En]: `An error occurred when sending the IDS`,
        [Locale.Pt]: 'Ocorreu um erro ao enviar o IDS',
        [Locale.Ge]: `An error occurred when sending the IDS`,
    },
    idsSentToPrint: {
        [Locale.Ru]: `ИДС отправлено на печать`,
        [Locale.Am]: `Տեղեկացված համաձայնությունն ուղարկվել է տպման`,
        [Locale.En]: `IDS sent for printing`,
        [Locale.Pt]: 'IDS enviado para impressão',
        [Locale.Ge]: `IDS sent for printing`,
    },
    idsSuccessful: {
        [Locale.Ru]: `ИДС успешно отправлено`,
        [Locale.Am]: `Տեղեկացված համաձայնությունը հաջողությամբ ուղարկվել է`,
        [Locale.En]: `IDS sent successfully`,
        [Locale.Pt]: 'IDS enviado com sucesso',
        [Locale.Ge]: `IDS sent successfully`,
    },
    entryWasSinged: {
        [Locale.Ru]: `Внимание запись была подписана`,
        [Locale.Am]: `Ուշադրություն, գրառումը ստորագրվել է`,
        [Locale.En]: `Attention, the entry was signed`,
        [Locale.Pt]: 'Atenção, a entrada foi assinada',
        [Locale.Ge]: `Attention, the entry was signed`,
    },
    entrySigned: {
        [Locale.Ru]: `Запись подписана`,
        [Locale.Am]: `Գրառումը ստորագրված է`,
        [Locale.En]: `Entry signed`,
        [Locale.Pt]: 'Entrada assinada',
        [Locale.Ge]: `Entry signed`,
    },
    entrySignedRefreshFailed: {
        [Locale.Ru]: `Не удалось обновить данные записи после подписи. Перезагрузите страницу.`,
        [Locale.Am]: `Ստորագրումից հետո գրառման տվյալները թարմացնել չհաջողվեց։ Վերաբեռնեք էջը։`,
        [Locale.En]: `Failed to refresh the entry data after signing. Reload the page.`,
        [Locale.Pt]: 'Não foi possível atualizar os dados da entrada após a assinatura. Recarregue a página.',
        [Locale.Ge]: `Failed to refresh the entry data after signing. Reload the page.`,
    },
    anotherUser: {
        [Locale.Ru]: `другим пользователем`,
        [Locale.Am]: `այլ օգտատիրոջ կողմից`,
        [Locale.En]: `another user`,
        [Locale.Pt]: 'outro usuário',
        [Locale.Ge]: `another user`,
    },
    needReloadPage: {
        [Locale.Ru]: `Для дальней работы необходимо перезагрузить страницу`,
        [Locale.Am]: `Հետագա աշխատանքի համար անհրաժեշտ է վերաբեռնել էջը`,
        [Locale.En]: `To work further, you need to reload the page`,
        [Locale.Pt]: 'Para continuar trabalhando, você precisa recarregar a página',
        [Locale.Ge]: `To work further, you need to reload the page`,
    },
    reloadPage: {
        [Locale.Ru]: `Перезагрузить страницу`,
        [Locale.Am]: `Վերաբեռնել էջը`,
        [Locale.En]: `Reload page`,
        [Locale.Pt]: 'Recarregar página',
        [Locale.Ge]: `Reload page`,
    },
    openAndAdd: {
        [Locale.Ru]: `Открыть и добавить`,
        [Locale.Am]: `Բացել և ավելացնել`,
        [Locale.En]: `Open and add`,
        [Locale.Pt]: 'Abra e adicione',
        [Locale.Ge]: `Open and add`,
    },
    testResult: {
        [Locale.Ru]: `Результаты анализов`,
        [Locale.Am]: `Անալիզների արդյունքներ`,
        [Locale.En]: `Test results`,
        [Locale.Pt]: 'Resultados do teste',
        [Locale.Ge]: `Test results`,
    },
    researchLinks: {
        [Locale.Ru]: `Ссылки на исследования`,
        [Locale.Am]: `Հետազոտությունների հղումներ`,
        [Locale.En]: `Research Links`,
        [Locale.Pt]: 'Links de pesquisa',
        [Locale.Ge]: `Research Links`,
    },
    refAndServiceWIllRemoveText: {
        [Locale.Ru]: `С этим медицинским случаем связаны направления и оказанные услуги. В случае его удаления они будут удалены.`,
        [Locale.Am]: `Այս բժշկական դեպքի հետ կապված են ուղեգրեր և մատուցված ծառայություններ։ Այն ջնջելու դեպքում դրանք կջնջվեն։`,
        [Locale.En]: `Referrals and services provided are associated with this medical case. If it is deleted, they will be deleted.`,
        [Locale.Pt]: 'Encaminhamentos e serviços prestados estão associados a este caso médico. Se for excluído, eles serão excluídos.',
        [Locale.Ge]: `Referrals and services provided are associated with this medical case. If it is deleted, they will be deleted.`,
    },
    sureToDeleteCase: {
        [Locale.Ru]: `Вы уверены, что хотите удалить этот медицинский случай?`,
        [Locale.Am]: `Իսկապե՞ս ուզում եք ջնջել այս բժշկական դեպքը`,
        [Locale.En]: `Are you sure you want to delete this medical case?`,
        [Locale.Pt]: 'Tem certeza de que deseja excluir este caso médico?',
        [Locale.Ge]: `Are you sure you want to delete this medical case?`,
    },
    refWillCancellText: {
        [Locale.Ru]: `При закрытии случая все связанные с ним неиспользованные направления будут отменены.`,
        [Locale.Am]: `Դեպքը փակելիս դրա հետ կապված բոլոր չօգտագործված ուղեգրերը կչեղարկվեն։`,
        [Locale.En]: `When a case is closed, all unused referrals associated with it will be cancelled.`,
        [Locale.Pt]: 'Quando um caso é encerrado, todas as referências não utilizadas associadas a ele serão canceladas.',
        [Locale.Ge]: `When a case is closed, all unused referrals associated with it will be cancelled.`,
    },
    sureToCloseCase: {
        [Locale.Ru]: `Вы уверены, что хотите закрыть этот медицинский случай?`,
        [Locale.Am]: `Իսկապե՞ս ուզում եք փակել այս բժշկական դեպքը`,
        [Locale.En]: `Are you sure you want to close this medical case?`,
        [Locale.Pt]: 'Tem certeza de que deseja encerrar este caso médico?',
        [Locale.Ge]: `Are you sure you want to close this medical case?`,
    },
    hasPaidServiceText: {
        [Locale.Ru]: `С данным медицинским случаем связана оплаченная услуга.`,
        [Locale.Am]: `Այս բժշկական դեպքի հետ կապված է վճարված ծառայություն։`,
        [Locale.En]: `There is a paid service associated with this medical case.`,
        [Locale.Pt]: 'Existe um serviço pago associado a este caso médico.',
        [Locale.Ge]: `There is a paid service associated with this medical case.`,
    },
    cantDeleteDiagnosisText: {
        [Locale.Ru]: `Невозможно удалить этот диагноз, но вы можете его отредактировать.`,
        [Locale.Am]: `Անհնար է ջնջել այս ախտորոշումը, սակայն կարող եք խմբագրել այն։`,
        [Locale.En]: `It is not possible to delete this diagnosis, but you can edit it.`,
        [Locale.Pt]: 'Não é possível excluir este diagnóstico, mas você pode editá-lo.',
        [Locale.Ge]: `It is not possible to delete this diagnosis, but you can edit it.`,
    },
    drugAlreadyAddedText: {
        [Locale.Ru]: `Данный медикамент уже добавлен в избранное`,
        [Locale.Am]: `Այս դեղամիջոցն արդեն ավելացված է ընտրյալներում`,
        [Locale.En]: `This medication has already been added to favorites`,
        [Locale.Pt]: 'Este medicamento já foi adicionado aos favoritos',
        [Locale.Ge]: `This medication has already been added to favorites`,
    },
    parameter: {
        [Locale.Ru]: `Параметр`,
        [Locale.Am]: `Պարամետր`,
        [Locale.En]: `Parameter`,
        [Locale.Pt]: 'Parâmetro',
        [Locale.Ge]: `Parameter`,
    },
    value: {
        [Locale.Ru]: `Значение`,
        [Locale.Am]: `Արժեք`,
        [Locale.En]: `Value`,
        [Locale.Pt]: 'Valentia',
        [Locale.Ge]: `Value`,
    },
    unit: {
        [Locale.Ru]: `Единица измерения`,
        [Locale.Am]: `Չափման միավոր`,
        [Locale.En]: `Unit`,
        [Locale.Pt]: 'Unidade',
        [Locale.Ge]: `Unit`,
    },
    minRefValue: {
        [Locale.Ru]: `Мин. референсное значение`,
        [Locale.Am]: `Նվազ. ռեֆերենսային արժեք`,
        [Locale.En]: `Min. reference value`,
        [Locale.Pt]: 'Min. valor de referência',
        [Locale.Ge]: `Min. reference value`,
    },
    maxRefValue: {
        [Locale.Ru]: `Макс. референсное значение`,
        [Locale.Am]: `Առավ. ռեֆերենսային արժեք`,
        [Locale.En]: `Max. reference value`,
        [Locale.Pt]: 'Máx. valor de referência',
        [Locale.Ge]: `Max. reference value`,
    },
    refValue: {
        [Locale.Ru]: `Референсное значение`,
        [Locale.Am]: `Ռեֆերենսային արժեք`,
        [Locale.En]: `Reference value`,
        [Locale.Pt]: 'Valor de referência',
        [Locale.Ge]: `Reference value`,
    },
    favForServiceExistsText: {
        [Locale.Ru]: `Избранное направление для данной услуги уже существует`,
        [Locale.Am]: `Այս ծառայության համար ընտրյալ ուղեգիր արդեն գոյություն ունի`,
        [Locale.En]: `A favorite referral for this service already exists`,
        [Locale.Pt]: 'Já existe uma referência favorita para este serviço',
        [Locale.Ge]: `A favorite referral for this service already exists`,
    },
    wasAddedAddOneMore: {
        [Locale.Ru]: `уже была сегодня выставлена. Создать еще одну?`,
        [Locale.Am]: `արդեն դուրս է գրվել այսօր։ Ստեղծե՞լ ևս մեկը`,
        [Locale.En]: `was already exhibited today. Create another one?`,
        [Locale.Pt]: 'já foi exibido hoje. Criar outro?',
        [Locale.Ge]: `was already exhibited today. Create another one?`,
    },
    errorOnRsCreated: {
        [Locale.Ru]: `Возникла ошибка при создании оказанной услуги`,
        [Locale.Am]: `Մատուցված ծառայությունը ստեղծելիս առաջացել է սխալ`,
        [Locale.En]: `An error occurred while creating the provided service.`,
        [Locale.Pt]: 'Ocorreu um erro ao criar o serviço fornecido.',
        [Locale.Ge]: `An error occurred while creating the provided service.`,
    },
    scanMarkingCode: {
        [Locale.Ru]: `Сканирование кода маркировки`,
        [Locale.Am]: `Մարկավորման կոդի սկանավորում`,
        [Locale.En]: `Scan marking code`,
        [Locale.Pt]: 'Digitalizar código de marcação',
        [Locale.Ge]: `Scan marking code`,
    },
    scanMarkingCodePlaceholder: {
        [Locale.Ru]: `Отсканируйте код`,
        [Locale.Am]: `Սկանավորեք կոդը`,
        [Locale.En]: `Scan the code`,
        [Locale.Pt]: 'Digitalize o código',
        [Locale.Ge]: `Scan the code`,
    },
    markingCodeForbiddenCharacters: {
        [Locale.Ru]: `Код содержит недопустимые символы. Отсканируйте код заново. (Возможно, надо поменять раскладку клавиатуры)`,
        [Locale.Am]: `Կոդը պարունակում է անթույլատրելի նիշեր։ Նորից սկանավորեք կոդը։ (Հնարավոր է՝ պետք է փոխել ստեղնաշարի դասավորությունը)`,
        [Locale.En]: `The code contains invalid characters. Scan the code again. (You may need to switch the keyboard layout)`,
        [Locale.Pt]: 'O código contém caracteres inválidos. Digitalize o código novamente. (Talvez seja necessário mudar o layout do teclado)',
        [Locale.Ge]: `კოდი შეიცავს დაუშვებელ სიმბოლოებს. თავიდან დაასკანერეთ კოდი. (შესაძლოა, საჭიროა კლავიატურის განლაგების შეცვლა)`,
    },
    productWithoutMarking: {
        [Locale.Ru]: `Продукт без маркировки`,
        [Locale.Am]: `Ապրանք առանց մարկավորման`,
        [Locale.En]: `Product without marking`,
        [Locale.Pt]: 'Produto sem marcação',
        [Locale.Ge]: `Product without marking`,
    },
    diagnosisNotSelected: {
        [Locale.Ru]: `Не выбран диагноз`,
        [Locale.Am]: `Ախտորոշում ընտրված չէ`,
        [Locale.En]: `Diagnosis not selected`,
        [Locale.Pt]: 'Diagnóstico não selecionado',
        [Locale.Ge]: `Diagnosis not selected`,
    },
    noReferralAnswered: {
        [Locale.Ru]: `Нет отвеченного направления`,
        [Locale.Am]: `Պատասխանված ուղեգիր չկա`,
        [Locale.En]: `No referral answered`,
        [Locale.Pt]: 'Nenhuma referência respondida',
        [Locale.Ge]: `No referral answered`,
    },
    noVaccinationsInEntry: {
        [Locale.Ru]: `В этой записи еще нет вакцинаций`,
        [Locale.Am]: `Այս գրառման մեջ դեռ պատվաստումներ չկան`,
        [Locale.En]: `There are no vaccinations in this entry yet.`,
        [Locale.Pt]: 'Ainda não há vacinas nesta entrada.',
        [Locale.Ge]: `There are no vaccinations in this entry yet.`,
    },
    addVaccination: {
        [Locale.Ru]: `Добавить вакцинацию`,
        [Locale.Am]: `Ավելացնել պատվաստում`,
        [Locale.En]: `Add vaccination`,
        [Locale.Pt]: 'Adicionar vacinação',
        [Locale.Ge]: `Add vaccination`,
    },
    patientHasNotActiveInsuranceProgram: {
        [Locale.Ru]: `У пациента нет активных страховых программ`,
        [Locale.Am]: `Պացիենտը չունի ակտիվ ապահովագրական ծրագրեր`,
        [Locale.En]: `The patient does not have active insurance programs`,
        [Locale.Pt]: 'O paciente não possui programas de seguro ativos',
        [Locale.Ge]: `The patient does not have active insurance programs`,
    },
    patientHasNoOutstandingServices: {
        [Locale.Ru]: `У пациента нет неоплаченных услуг`,
        [Locale.Am]: `Պացիենտը չունի չվճարված ծառայություններ`,
        [Locale.En]: `The patient has no outstanding services`,
        [Locale.Ge]: `The patient has no outstanding services`,
        [Locale.Pt]: `O doente não tem serviços pendentes.`,
    },
    viewAllProgramsDetails: {
        [Locale.Ru]: `Посмотреть подробности по всем программам`,
        [Locale.Am]: `Դիտել բոլոր ծրագրերի մանրամասները`,
        [Locale.En]: `View all programs details`,
        [Locale.Pt]: 'Veja todos os detalhes dos programas',
        [Locale.Ge]: `View all programs details`,
    },
    referralCut: {
        [Locale.Ru]: `направлен`,
        [Locale.Am]: `ուղեգր`,
        [Locale.En]: `referra`,
        [Locale.Pt]: 'referência',
        [Locale.Ge]: `referra`,
    },
    conclusionCut: {
        [Locale.Ru]: `заключен`,
        [Locale.Am]: `եզրակաց`,
        [Locale.En]: `conclusion`,
        [Locale.Pt]: 'conclusão',
        [Locale.Ge]: `conclusion`,
    },
    resultOfCut: {
        [Locale.Ru]: `итоги зап`,
        [Locale.Am]: `ամփոփ`,
        [Locale.En]: `results of `,
        [Locale.Pt]: 'resultados de',
        [Locale.Ge]: `results of `,
    },
    insuranceCut: {
        [Locale.Ru]: 'страхов',
        [Locale.Am]: 'ապահովագր',
        [Locale.En]: 'insurance',
        [Locale.Pt]: 'seguro',
        [Locale.Ge]: 'insurance',
    },
    recordId: {
        [Locale.Ru]: `Номер медкарты`,
        [Locale.Am]: `Բժշկական քարտի համար`,
        [Locale.En]: `Record id`,
        [Locale.Pt]: 'ID do registro',
        [Locale.Ge]: `Record id`,
    },
    dateOfReception: {
        [Locale.Ru]: `Дата приёма`,
        [Locale.Am]: `Ընդունելության ամսաթիվ`,
        [Locale.En]: `Date of reception`,
        [Locale.Pt]: 'Data de recepção',
        [Locale.Ge]: `Date of reception`,
    },
    EntryInMedicalRecordFrom: {
        [Locale.Ru]: `Запись от`,
        [Locale.Am]: `Գրառում՝`,
        [Locale.En]: `Entry from`,
        [Locale.Pt]: 'Registro de',
        [Locale.Ge]: `Entry from`,
    },
    subjective: {
        [Locale.Ru]: `Субъективные данные`,
        [Locale.Am]: `Սուբյեկտիվ տվյալներ`,
        [Locale.En]: `Subjective`,
        [Locale.Pt]: 'Subjetivo',
        [Locale.Ge]: `Subjective`,
    },
    objective: {
        [Locale.Ru]: `Объективные`,
        [Locale.Am]: `Օբյեկտիվ`,
        [Locale.En]: `Objective`,
        [Locale.Pt]: 'Mirar',
        [Locale.Ge]: `Objective`,
    },
    assessmentLikeEpisodes: {
        [Locale.Ru]: `Оценка`,
        [Locale.Am]: `Գնահատում`,
        [Locale.En]: `Assessment`,
        [Locale.Pt]: 'Avaliação',
        [Locale.Ge]: `Assessment`,
    },
    entryPagePlan: {
        [Locale.Ru]: `План`,
        [Locale.Am]: `Պլան`,
        [Locale.En]: `Plan`,
        [Locale.Pt]: 'Plano',
        [Locale.Ge]: `Plan`,
    },
    review: {
        [Locale.Ru]: `Проверка`,
        [Locale.Am]: `Ստուգում`,
        [Locale.En]: `Review`,
        [Locale.Pt]: 'Revisão',
        [Locale.Ge]: `Review`,
    },
    sendEntryForReview: {
        [Locale.Ru]: `Отправьте запись на проверку`,
        [Locale.Am]: `Ուղարկեք գրառումը ստուգման`,
        [Locale.En]: `Send the entry for review`,
        [Locale.Pt]: 'Envie o registro para revisão',
        [Locale.Ge]: `Send the entry for review`,
    },
    entryReviewDescription: {
        [Locale.Ru]: `Ai проверит запись, поставит оценку и подскажет, что улучшить`,
        [Locale.Am]: `Ai-ն կստուգի գրառումը, կգնահատի և կհուշի, թե ինչ բարելավել`,
        [Locale.En]: `Ai will review the entry, grade it and suggest what to improve`,
        [Locale.Pt]: 'A IA vai revisar o registro, avaliá-lo e sugerir o que melhorar',
        [Locale.Ge]: `Ai will review the entry, grade it and suggest what to improve`,
    },
    entryReviewInProgress: {
        [Locale.Ru]: `Проверяем медицинскую запись`,
        [Locale.Am]: `Ստուգում ենք բժշկական գրառումը`,
        [Locale.En]: `Reviewing the medical entry`,
        [Locale.Pt]: 'Revisando o registro médico',
        [Locale.Ge]: `Reviewing the medical entry`,
    },
    entryReviewInProgressDescription: {
        [Locale.Ru]: `Это может занять 3-10 минут. Редактирование недоступно`,
        [Locale.Am]: `Սա կարող է տևել 3-10 րոպե։ Խմբագրումն անհասանելի է`,
        [Locale.En]: `It may take 3-10 minutes. Editing is unavailable`,
        [Locale.Pt]: 'Pode levar 3-10 minutos. A edição não está disponível',
        [Locale.Ge]: `It may take 3-10 minutes. Editing is unavailable`,
    },
    hasCriticalErrors: {
        [Locale.Ru]: `Есть критические ошибки`,
        [Locale.Am]: `Կան կրիտիկական սխալներ`,
        [Locale.En]: `There are critical errors`,
        [Locale.Pt]: 'Há erros críticos',
        [Locale.Ge]: `There are critical errors`,
    },
    fixCriticalErrorsBeforeReview: {
        [Locale.Ru]: `Исправьте их прежде чем отправить запись на проверку`,
        [Locale.Am]: `Ուղղեք դրանք՝ նախքան գրառումը ստուգման ուղարկելը`,
        [Locale.En]: `Fix them before sending the entry for review`,
        [Locale.Pt]: 'Corrija-os antes de enviar o registro para revisão',
        [Locale.Ge]: `Fix them before sending the entry for review`,
    },
    hasRoomForImprovement: {
        [Locale.Ru]: `Есть что улучшить`,
        [Locale.Am]: `Կա ինչ բարելավել`,
        [Locale.En]: `There is room for improvement`,
        [Locale.Pt]: 'Há o que melhorar',
        [Locale.Ge]: `There is room for improvement`,
    },
    veryGood: {
        [Locale.Ru]: `Очень хорошо`,
        [Locale.Am]: `Շատ լավ`,
        [Locale.En]: `Very good`,
        [Locale.Pt]: 'Muito bom',
        [Locale.Ge]: `Very good`,
    },
    manyShortcomings: {
        [Locale.Ru]: `Много недоработок`,
        [Locale.Am]: `Շատ թերություններ`,
        [Locale.En]: `Many shortcomings`,
        [Locale.Pt]: 'Muitas falhas',
        [Locale.Ge]: `Many shortcomings`,
    },
    perfect: {
        [Locale.Ru]: `Идеально!`,
        [Locale.Am]: `Կատարյալ է։`,
        [Locale.En]: `Perfect!`,
        [Locale.Pt]: 'Perfeito!',
        [Locale.Ge]: `Perfect!`,
    },
    reviewFinished: {
        [Locale.Ru]: `Проверка завершена`,
        [Locale.Am]: `Ստուգումն ավարտված է`,
        [Locale.En]: `Review completed`,
        [Locale.Pt]: 'Revisão concluída',
        [Locale.Ge]: `Review completed`,
    },
    $reviewCompletedAtSubtitle: {
        [Locale.Ru]: `$date (длилась $duration)`,
        [Locale.Am]: `$date (տևել է $duration)`,
        [Locale.En]: `$date (took $duration)`,
        [Locale.Pt]: '$date (durou $duration)',
        [Locale.Ge]: `$date (took $duration)`,
    },
    entryChanged: {
        [Locale.Ru]: `Внесены изменения`,
        [Locale.Am]: `Կատարվել են փոփոխություններ`,
        [Locale.En]: `Changes made`,
        [Locale.Pt]: 'Alterações feitas',
        [Locale.Ge]: `Changes made`,
    },
    sendEntryForReReview: {
        [Locale.Ru]: `Отправьте запись на повторную проверку`,
        [Locale.Am]: `Ուղարկեք գրառումը կրկնակի ստուգման`,
        [Locale.En]: `Send the entry for re-review`,
        [Locale.Pt]: 'Envie o registro para nova revisão',
        [Locale.Ge]: `Send the entry for re-review`,
    },
    reviewRequiredBeforePublishTitle: {
        [Locale.Ru]: `Запись нельзя опубликовать без проверки`,
        [Locale.Am]: `Գրառումը հնարավոր չէ հրապարակել առանց ստուգման`,
        [Locale.En]: `The entry cannot be published without review`,
        [Locale.Pt]: 'O registro não pode ser publicado sem revisão',
        [Locale.Ge]: `The entry cannot be published without review`,
    },
    reviewRequiredBeforePublishDescription: {
        [Locale.Ru]: `Сначала отправьте запись на проверку и дождитесь её завершения`,
        [Locale.Am]: `Նախ ուղարկեք գրառումը ստուգման և սպասեք դրա ավարտին`,
        [Locale.En]: `Send the entry for review first and wait for it to complete`,
        [Locale.Pt]: 'Envie o registro para revisão primeiro e aguarde a conclusão',
        [Locale.Ge]: `Send the entry for review first and wait for it to complete`,
    },
    check: {
        [Locale.Ru]: `Проверить`,
        [Locale.Am]: `Ստուգել`,
        [Locale.En]: `Review`,
        [Locale.Pt]: 'Revisar',
        [Locale.Ge]: `Review`,
    },
    $scoreOutOfMax: {
        [Locale.Ru]: `из $max`,
        [Locale.Am]: `$max-ից`,
        [Locale.En]: `out of $max`,
        [Locale.Pt]: 'de $max',
        [Locale.Ge]: `out of $max`,
    },
    $completedEpisode: {
        [Locale.Ru]: `Завершенный эпизод «$name»`,
        [Locale.Am]: `Ավարտված էպիզոդ «$name»`,
        [Locale.En]: `Completed episode «$name»`,
        [Locale.Pt]: 'Episódio concluído «$name»',
        [Locale.Ge]: `Completed episode «$name»`,
    },
    episodeClosedOnTime: {
        [Locale.Ru]: `Эпизод закрыт вовремя`,
        [Locale.Am]: `Էպիզոդը փակվել է ժամանակին`,
        [Locale.En]: `Episode closed on time`,
        [Locale.Pt]: 'Episódio encerrado no prazo',
        [Locale.Ge]: `Episode closed on time`,
    },
    episodeClosedPrematurely: {
        [Locale.Ru]: `Эпизод закрыт преждевременно`,
        [Locale.Am]: `Էպիզոդը փակվել է վաղաժամ`,
        [Locale.En]: `Episode closed prematurely`,
        [Locale.Pt]: 'Episódio encerrado prematuramente',
        [Locale.Ge]: `Episode closed prematurely`,
    },
    episodeMaybeClosedPrematurely: {
        [Locale.Ru]: `Возможно, эпизод закрыт преждевременно`,
        [Locale.Am]: `Հնարավոր է՝ էպիզոդը փակվել է վաղաժամ`,
        [Locale.En]: `The episode may have been closed prematurely`,
        [Locale.Pt]: 'O episódio pode ter sido encerrado prematuramente',
        [Locale.Ge]: `The episode may have been closed prematurely`,
    },
    episodeClosureTimelinessHint: {
        [Locale.Ru]: `Ai рассчитывает своевременность закрытия эпизода на основе выполненных действий в плане лечения и оставшихся задач`,
        [Locale.Am]: `Ai-ն հաշվարկում է էպիզոդի փակման ժամանակին լինելը՝ ելնելով բուժման պլանում կատարված գործողություններից և մնացած առաջադրանքներից`,
        [Locale.En]: `AI estimates the timeliness of closing the episode based on completed actions in the treatment plan and remaining tasks`,
        [Locale.Pt]: 'A IA calcula a oportunidade de encerrar o episódio com base nas ações concluídas no plano de tratamento e nas tarefas restantes',
        [Locale.Ge]: `AI estimates the timeliness of closing the episode based on completed actions in the treatment plan and remaining tasks`,
    },
    unfinishedTasks: {
        [Locale.Ru]: `Незавершенные задачи`,
        [Locale.Am]: `Չավարտված առաջադրանքներ`,
        [Locale.En]: `Unfinished tasks`,
        [Locale.Pt]: 'Tarefas inacabadas',
        [Locale.Ge]: `Unfinished tasks`,
    },
    activeFollowUps: {
        [Locale.Ru]: `Активные follow-up`,
        [Locale.Am]: `Ակտիվ follow-up`,
        [Locale.En]: `Active follow-ups`,
        [Locale.Pt]: 'Follow-ups ativos',
        [Locale.Ge]: `Active follow-ups`,
    },
    whyItMatters: {
        [Locale.Ru]: `Почему важно выполнить`,
        [Locale.Am]: `Ինչու է կարևոր կատարել`,
        [Locale.En]: `Why it matters`,
        [Locale.Pt]: 'Por que é importante',
        [Locale.Ge]: `Why it matters`,
    },
    orderTest: {
        [Locale.Ru]: `Назначить исследование`,
        [Locale.Am]: `Նշանակել հետազոտություն`,
        [Locale.En]: `Order a test`,
        [Locale.Pt]: 'Solicitar exame',
        [Locale.Ge]: `Order a test`,
    },
    awaitResults: {
        [Locale.Ru]: `Дождаться результатов`,
        [Locale.Am]: `Սպասել արդյունքներին`,
        [Locale.En]: `Await results`,
        [Locale.Pt]: 'Aguardar resultados',
        [Locale.Ge]: `Await results`,
    },
    followUpVisit: {
        [Locale.Ru]: `Повторный прием`,
        [Locale.Am]: `Կրկնակի ընդունելություն`,
        [Locale.En]: `Follow-up visit`,
        [Locale.Pt]: 'Consulta de retorno',
        [Locale.Ge]: `Follow-up visit`,
    },
    referToSpecialist: {
        [Locale.Ru]: `Направить к специалисту`,
        [Locale.Am]: `Ուղեգրել մասնագետի մոտ`,
        [Locale.En]: `Refer to a specialist`,
        [Locale.Pt]: 'Encaminhar ao especialista',
        [Locale.Ge]: `Refer to a specialist`,
    },
    monitoring: {
        [Locale.Ru]: `Контроль`,
        [Locale.Am]: `Հսկողություն`,
        [Locale.En]: `Reassess after treatment`,
        [Locale.Pt]: 'Reavaliação',
        [Locale.Ge]: `Reassess after treatment`,
    },
    clarifyDocumentation: {
        [Locale.Ru]: `Уточнить документацию`,
        [Locale.Am]: `Ճշտել փաստաթղթերը`,
        [Locale.En]: `Clarify documentation`,
        [Locale.Pt]: 'Esclarecer documentação',
        [Locale.Ge]: `Clarify documentation`,
    },
    entryFilling: {
        [Locale.Ru]: `Заполнение записи`,
        [Locale.Am]: `Գրառման լրացում`,
        [Locale.En]: `Entry filling`,
        [Locale.Pt]: 'Preenchimento da entrada',
        [Locale.Ge]: `Entry filling`,
    },
    criticalErrors: {
        [Locale.Ru]: `Критичные ошибки`,
        [Locale.Am]: `Կրիտիկական սխալներ`,
        [Locale.En]: `Critical errors`,
        [Locale.Pt]: 'Erros críticos',
        [Locale.Ge]: `Critical errors`,
    },
    generalComment: {
        [Locale.Ru]: `Общий комментарий`,
        [Locale.Am]: `Ընդհանուր մեկնաբանություն`,
        [Locale.En]: `General comment`,
        [Locale.Pt]: 'Comentário geral',
        [Locale.Ge]: `General comment`,
    },
    whatWasGood: {
        [Locale.Ru]: `Что было хорошо`,
        [Locale.Am]: `Ինչն էր լավ`,
        [Locale.En]: `What was good`,
        [Locale.Pt]: 'O que esteve bom',
        [Locale.Ge]: `What was good`,
    },
    whatCanBeImproved: {
        [Locale.Ru]: `Что можно улучшить`,
        [Locale.Am]: `Ինչը կարելի է բարելավել`,
        [Locale.En]: `What can be improved`,
        [Locale.Pt]: 'O que pode ser melhorado',
        [Locale.Ge]: `What can be improved`,
    },
    documentationManagement: {
        [Locale.Ru]: `Ведение документации`,
        [Locale.Am]: `Փաստաթղթավարություն`,
        [Locale.En]: `Documentation`,
        [Locale.Pt]: 'Documentação',
        [Locale.Ge]: `Documentation`,
    },
    treatmentJustification: {
        [Locale.Ru]: `Обоснованность лечения`,
        [Locale.Am]: `Բուժման հիմնավորվածություն`,
        [Locale.En]: `Treatment justification`,
        [Locale.Pt]: 'Justificativa do tratamento',
        [Locale.Ge]: `Treatment justification`,
    },
    diseaseHistory: {
        [Locale.Ru]: `История заболевания`,
        [Locale.Am]: `Հիվանդության պատմություն`,
        [Locale.En]: `History of present illness`,
        [Locale.Pt]: 'Histórico da doença',
        [Locale.Ge]: `History of present illness`,
    },
    clinicalReasoning: {
        [Locale.Ru]: `Клиническое обоснование`,
        [Locale.Am]: `Կլինիկական հիմնավորում`,
        [Locale.En]: `Clinical reasoning`,
        [Locale.Pt]: 'Raciocínio clínico',
        [Locale.Ge]: `Clinical reasoning`,
    },
    diagnosisFormatting: {
        [Locale.Ru]: `Оформление диагноза`,
        [Locale.Am]: `Ախտորոշման ձևակերպում`,
        [Locale.En]: `Diagnosis formatting`,
        [Locale.Pt]: 'Formatação do diagnóstico',
        [Locale.Ge]: `Diagnosis formatting`,
    },
    diagnosisValidity: {
        [Locale.Ru]: `Достоверность диагноза`,
        [Locale.Am]: `Ախտորոշման հավաստիություն`,
        [Locale.En]: `Diagnosis validity`,
        [Locale.Pt]: 'Validade do diagnóstico',
        [Locale.Ge]: `Diagnosis validity`,
    },
    referralJustification: {
        [Locale.Ru]: `Обоснованность направлений`,
        [Locale.Am]: `Ուղեգրերի հիմնավորվածություն`,
        [Locale.En]: `Referral justification`,
        [Locale.Pt]: 'Justificativa dos encaminhamentos',
        [Locale.Ge]: `Referral justification`,
    },
    workupStrategy: {
        [Locale.Ru]: `Стратегия обследования`,
        [Locale.Am]: `Հետազոտման ռազմավարություն`,
        [Locale.En]: `Workup strategy`,
        [Locale.Pt]: 'Estratégia de investigação',
        [Locale.Ge]: `Workup strategy`,
    },
    treatmentStrategy: {
        [Locale.Ru]: `Стратегия лечения`,
        [Locale.Am]: `Բուժման ռազմավարություն`,
        [Locale.En]: `Treatment strategy`,
        [Locale.Pt]: 'Estratégia de tratamento',
        [Locale.Ge]: `Treatment strategy`,
    },
    needsFixing: {
        [Locale.Ru]: `Нужно исправить`,
        [Locale.Am]: `Անհրաժեշտ է ուղղել`,
        [Locale.En]: `Needs fixing`,
        [Locale.Pt]: 'Precisa de correção',
        [Locale.Ge]: `Needs fixing`,
    },
    consultationRequest: {
        [Locale.Ru]: `У пациента есть направления, на которые вы можете ответить.\nУточните повод обращения и ответьте на направление, если необходимо`,
        [Locale.Am]: `Պացիենտն ունի ուղեգրեր, որոնց դուք կարող եք պատասխանել։\nՃշտեք դիմելու պատճառը և պատասխանեք ուղեգրին, եթե անհրաժեշտ է`,
        [Locale.En]: `The patient has referrals that you can respond to.\nSpecify the reason for the visit and respond to the referral if necessary`,
        [Locale.Pt]: 'O paciente tem encaminhamentos aos quais você pode responder.\nEspecifique o motivo da consulta e responda ao encaminhamento se necessário',
        [Locale.Ge]: `The patient has referrals that you can respond to.\nSpecify the reason for the visit and respond to the referral if necessary`,
    },
    patientHasReferralsFromOtherDoctors: {
        [Locale.Ru]: `У пациента есть направления от других докторов`,
        [Locale.Am]: `Պացիենտն ունի ուղեգրեր այլ բժիշկներից`,
        [Locale.En]: `The patient has referrals from other doctors`,
        [Locale.Pt]: 'O paciente tem encaminhamentos de outros médicos',
        [Locale.Ge]: `The patient has referrals from other doctors`,
    },
    toSubjective: {
        [Locale.Ru]: `К субъективным данным`,
        [Locale.Am]: `Դեպի սուբյեկտիվ տվյալներ`,
        [Locale.En]: `To subjective`,
        [Locale.Pt]: 'Para subjetivo',
        [Locale.Ge]: `To subjective`,
    },
    toObjective: {
        [Locale.Ru]: `К объективному`,
        [Locale.Am]: `Դեպի օբյեկտիվ`,
        [Locale.En]: `To objective`,
        [Locale.Pt]: 'Para objetivar',
        [Locale.Ge]: `To objective`,
    },
    toAssessmentLikeEpisodes: {
        [Locale.Ru]: `К итогам`,
        [Locale.Am]: `Դեպի ամփոփում`,
        [Locale.En]: `To assessment`,
        [Locale.Pt]: 'Para avaliação',
        [Locale.Ge]: `To assessment`,
    },
    toTreatmentPlan: {
        [Locale.Ru]: `К плану`,
        [Locale.Am]: `Դեպի պլան`,
        [Locale.En]: `To plan`,
        [Locale.Pt]: 'Planejar',
        [Locale.Ge]: `To plan`,
    },
    toBilling: {
        [Locale.Ru]: `К услугам`,
        [Locale.Am]: `Դեպի ծառայություններ`,
        [Locale.En]: `To billing`,
        [Locale.Pt]: 'Para cobrança',
        [Locale.Ge]: `To billing`,
    },
    toReview: {
        [Locale.Ru]: `К проверке`,
        [Locale.Am]: `Դեպի ստուգում`,
        [Locale.En]: `To review`,
        [Locale.Pt]: 'Para revisão',
        [Locale.Ge]: `To review`,
    },
    noAhealthContactTitle: {
        [Locale.Ru]: `Не можем отправить контакты`,
        [Locale.Am]: `Չենք կարող ուղարկել կոնտակտները`,
        [Locale.En]: `We can't send contacts`,
        [Locale.Pt]: 'Não conseguimos enviar contatos',
        [Locale.Ge]: `We can't send contacts`,
    },
    needRegisterInTgBot: {
        [Locale.Ru]: `Необходимо зарегистрироваться в телеграм боте.
Для этого в профиле необходимо нажать "Зарегистрироваться в чате"`,
        [Locale.Am]: `Անհրաժեշտ է գրանցվել թելեգրամ բոտում։
Դրա համար պրոֆիլում պետք է սեղմել "Գրանցվել չաթում"`,
        [Locale.En]: `You need to register in the telegram bot.
To do this, in your profile, you need to click "Register in chat"`,
        [Locale.Pt]: `Precisa de se registar no bot do Telegram.
Para tal, no seu perfil, precisa de clicar em "Registar no chat".`,
        [Locale.Ge]: `You need to register in the telegram bot.
To do this, in your profile, you need to click "Register in chat"`,
    },
    mkbTitle: {
        [Locale.Ru]: `Назначьте код по МКБ-10 и диагноз для каждого эпизода`,
        [Locale.Am]: `Նշանակեք ՀՄԴ-10 կոդը և ախտորոշումը յուրաքանչյուր էպիզոդի համար`,
        [Locale.En]: `Assign a code according to the ICD-10 and diagnosis for each episode`,
        [Locale.Pt]: 'Atribuir um código de acordo com a CID-10 e diagnóstico para cada episódio',
        [Locale.Ge]: `Assign a code according to the ICD-10 and diagnosis for each episode`,
    },
    sickLeave: {
        [Locale.Ru]: `Больничный лист`,
        [Locale.Am]: `Անաշխատունակության թերթիկ`,
        [Locale.En]: `Sick leave`,
        [Locale.Pt]: 'Licença médica',
        [Locale.Ge]: `Sick leave`,
    },
    endEpisodeDescription: {
        [Locale.Ru]: `Эпизод будет закрыт при публикации записи. Направления, медикаменты, рекомендации и задания в плане лечения будут отменены`,
        [Locale.Am]: `Էպիզոդը կփակվի գրառման հրապարակման ժամանակ։ Բուժման պլանում ուղեգրերը, դեղամիջոցները, հանձնարարականները և առաջադրանքները կչեղարկվեն`,
        [Locale.En]: `Medical case will be closed on entry publishing. Referrals, medications, recommendations and tasks in the treatment plan will be canceled`,
        [Locale.Pt]: 'O caso médico será encerrado na publicação da entrada. Encaminhamentos, medicamentos, recomendações e tarefas do plano de tratamento serão cancelados',
        [Locale.Ge]: `Medical case will be closed on entry publishing. Referrals, medications, recommendations and tasks in the treatment plan will be canceled`,
    },
    takeSelfEpisodeDescription: {
        [Locale.Ru]: `Менеджер эпизода получит уведомление о том, что вы забрали эпизод себе`,
        [Locale.Am]: `Էպիզոդի մենեջերը ծանուցում կստանա այն մասին, որ դուք վերցրել եք էպիզոդը ձեզ`,
        [Locale.En]: `The episode manager will receive a notification that you took the episode yourself`,
        [Locale.Pt]: 'O gerenciador de episódios receberá uma notificação de que você mesmo gravou o episódio',
        [Locale.Ge]: `The episode manager will receive a notification that you took the episode yourself`,
    },
    confirmCloseEpisodeButtonMessage: {
        [Locale.Ru]: `Пациент получит сообщение с вашим комментарием`,
        [Locale.Am]: `Պացիենտը կստանա հաղորդագրություն ձեր մեկնաբանությամբ`,
        [Locale.En]: `The patient will receive a message with your comment`,
        [Locale.Pt]: 'O paciente receberá uma mensagem com seu comentário',
        [Locale.Ge]: `The patient will receive a message with your comment`,
    },
    ifWorkCanceledPublishEntry: {
        [Locale.Ru]: `Если работа закончена, опубликуйте запись`,
        [Locale.Am]: `Եթե աշխատանքն ավարտված է, հրապարակեք գրառումը`,
        [Locale.En]: `If the work is finished, publish the entry`,
        [Locale.Pt]: 'Se o trabalho for concluído, publique a entrada',
        [Locale.Ge]: `If the work is finished, publish the entry`,
    },
    patientStateControlIsNotRequired: {
        [Locale.Ru]: `Контроль состояния пациента не требуется`,
        [Locale.Am]: `Պացիենտի վիճակի հսկողություն չի պահանջվում`,
        [Locale.En]: `Patient state control is not required`,
        [Locale.Pt]: 'O controle do estado do paciente não é necessário',
        [Locale.Ge]: `Patient state control is not required`,
    },
    filedsUpdateError: {
        [Locale.Ru]: `Ошибка при сохранении данных записи`,
        [Locale.Am]: `Գրառման տվյալները պահպանելիս սխալ`,
        [Locale.En]: `Error saving record data`,
        [Locale.Pt]: 'Erro ao salvar dados do registro',
        [Locale.Ge]: `Error saving record data`,
    },
    posibleChangesNotSaveText: {
        [Locale.Ru]: `Возможно не сохранились изменения для полей:`,
        [Locale.Am]: `Հնարավոր է՝ չեն պահպանվել փոփոխությունները դաշտերի համար՝`,
        [Locale.En]: `It is possible that changes to the fields were not saved:`,
        [Locale.Pt]: 'É possível que as alterações nos campos não tenham sido salvas:',
        [Locale.Ge]: `It is possible that changes to the fields were not saved:`,
    },
    canRefrashToCheckText: {
        [Locale.Ru]: `Можно перезагрузить страницу, чтобы проверить что было сохранено`,
        [Locale.Am]: `Կարելի է վերաբեռնել էջը՝ ստուգելու համար, թե ինչ է պահպանվել`,
        [Locale.En]: `You can refresh the page to check what was saved.`,
        [Locale.Pt]: 'Você pode atualizar a página para verificar o que foi salvo.',
        [Locale.Ge]: `You can refresh the page to check what was saved.`,
    },
    authorMustBeDoctorText: {
        [Locale.Ru]: `Автором услуги должен быть доктор`,
        [Locale.Am]: `Ծառայության հեղինակը պետք է լինի բժիշկ`,
        [Locale.En]: `The author of the service must be a doctor`,
        [Locale.Pt]: 'O autor do serviço deve ser médico',
        [Locale.Ge]: `The author of the service must be a doctor`,
    },
    selectDoctorAsAuthorText: {
        [Locale.Ru]: `Укажите пользователя с ролью доктор в качестве доктора записи`,
        [Locale.Am]: `Նշեք բժիշկ դերով օգտատիրոջը որպես գրառման բժիշկ`,
        [Locale.En]: `Specify a user with the role doctor as the record's doctor`,
        [Locale.Pt]: 'Especifique um usuário com a função de médico como médico do registro',
        [Locale.Ge]: `Specify a user with the role doctor as the record's doctor`,
    },
    assistantVantSign: {
        [Locale.Ru]: `Подписать запись может только доктор`,
        [Locale.Am]: `Գրառումը կարող է ստորագրել միայն բժիշկը`,
        [Locale.En]: `Only a doctor can sign the entry.`,
        [Locale.Pt]: 'Somente um médico pode assinar a entrada.',
        [Locale.Ge]: `Only a doctor can sign the entry.`,
    },
    selectOfficeForAppointment: {
        [Locale.Ru]: `Выберите кабинет, в котором проходит приём`,
        [Locale.Am]: `Ընտրեք կաբինետը, որտեղ անցնում է ընդունելությունը`,
        [Locale.En]: `Select the office where the appointment takes place`,
        [Locale.Pt]: 'Selecione o escritório onde a consulta é realizada',
        [Locale.Ge]: `Select the office where the appointment takes place`,
    },
    selectAuthor: {
        [Locale.Ru]: `Выберите автора`,
        [Locale.Am]: `Ընտրեք հեղինակին`,
        [Locale.En]: `Select the author`,
        [Locale.Pt]: 'Selecione o autor',
        [Locale.Ge]: `Select the author`,
    },
    selectDoctorForAppointment: {
        [Locale.Ru]: `Выберите автора записи`,
        [Locale.Am]: `Ընտրեք գրառման հեղինակին`,
        [Locale.En]: `Select the author of the entry`,
        [Locale.Pt]: 'Selecione o autor da entrada',
        [Locale.Ge]: `Select the author of the entry`,
    },
    docrorMustBeAthor: {
        [Locale.Ru]: `Автором записи должен быть доктор`,
        [Locale.Am]: `Գրառման հեղինակը պետք է լինի բժիշկ`,
        [Locale.En]: `The author of the entry must be a doctor`,
        [Locale.Pt]: 'O autor da entrada deve ser médico',
        [Locale.Ge]: `The author of the entry must be a doctor`,
    },
    createPatientFileEntry: {
        [Locale.Ru]: `Создать запись "Прикрепленный документ"`,
        [Locale.Am]: `Ստեղծել "Կցված փաստաթուղթ" գրառում`,
        [Locale.En]: `Create a post "Attached Document"`,
        [Locale.Pt]: `Criar um registro \"Documento anexado\"`,
        [Locale.Ge]: `Create a post "Attached Document"`,
    },
    laboratoryTestsDisabledTitle: {
        [Locale.Ru]: `Тип этой записи нельзя изменить.`,
        [Locale.Am]: `Այս գրառման տեսակը հնարավոր չէ փոփոխել։`,
        [Locale.En]: `Type of this entry cannot be changed.`,
        [Locale.Pt]: 'O tipo desta entrada não pode ser alterado.',
        [Locale.Ge]: `Type of this entry cannot be changed.`,
    },
    laboratoryTestsDisabledHelpingText: {
        [Locale.Ru]: `Создайте новую запись, если вам нужен другой тип.`,
        [Locale.Am]: `Ստեղծեք նոր գրառում, եթե ձեզ անհրաժեշտ է այլ տեսակ։`,
        [Locale.En]: `Create a new entry if you need other type.`,
        [Locale.Pt]: 'Crie uma nova entrada se precisar de outro tipo.',
        [Locale.Ge]: `Create a new entry if you need other type.`,
    },
    selectPractForMatText: {
        [Locale.Ru]: `Выберите в какой практике будет использован материал`,
        [Locale.Am]: `Ընտրեք, թե որ պրակտիկայում կօգտագործվի նյութը`,
        [Locale.En]: `Select the practice in which the material will be used`,
        [Locale.Pt]: 'Selecione a prática em que o material será utilizado',
        [Locale.Ge]: `Select the practice in which the material will be used`,
    },
    materialWooUsed: {
        [Locale.Ru]: `Материал будет использован`,
        [Locale.Am]: `Նյութը կօգտագործվի`,
        [Locale.En]: `The material will be used`,
        [Locale.Pt]: 'O material será usado',
        [Locale.Ge]: `The material will be used`,
    },
    materialBelongs: {
        [Locale.Ru]: `Материал принадлежит`,
        [Locale.Am]: `Նյութը պատկանում է`,
        [Locale.En]: `The material belongs to`,
        [Locale.Pt]: 'O material pertence a',
        [Locale.Ge]: `The material belongs to`,
    },
    patientDontUseChaikaChatForPracticeText: {
        [Locale.Ru]: `Пациент не пользуется Chaika Chat. Выберите практику и отправите приглашение для создания чата`,
        [Locale.Am]: `Պացիենտը չի օգտվում Chaika Chat-ից։ Ընտրեք պրակտիկան և ուղարկեք հրավեր չաթ ստեղծելու համար`,
        [Locale.En]: `The patient doesn't use Chaika Chat. Select a practice and send an invitation to create a chat.`,
        [Locale.Pt]: 'O paciente não usa o Chaika Chat. Selecione uma prática e envie um convite para criar um chat.',
        [Locale.Ge]: `The patient doesn't use Chaika Chat. Select a practice and send an invitation to create a chat.`,
    },
    hasSubscription: {
        [Locale.Ru]: `Есть подписка`,
        [Locale.Am]: `Կա բաժանորդագրություն`,
        [Locale.En]: `There is a subscription`,
        [Locale.Pt]: 'Existe uma assinatura',
        [Locale.Ge]: `There is a subscription`,
    },
    anotherDoctorWantsToCloseMedicalCase: {
        [Locale.Ru]: `Доктор $doctorName хочет закрыть эпизод. Свяжитесь с ним, если вы хотите взять эпизод себе`,
        [Locale.Am]: `$doctorName բժիշկը ցանկանում է փակել էպիզոդը։ Կապվեք նրա հետ, եթե ցանկանում եք վերցնել էպիզոդը ձեզ`,
        [Locale.En]: `Doctor $doctorName wants to close medical case. Contact him if you want to take medical case`,
        [Locale.Pt]: 'Doutor $doctorName quer encerrar caso médico. Entre em contato com ele se quiser levar um caso médico',
        [Locale.Ge]: `Doctor $doctorName wants to close medical case. Contact him if you want to take medical case`,
    },
    userHasTasks: {
        [Locale.Ru]: `У пользователя остались задания`,
        [Locale.Am]: `Օգտատիրոջ մոտ մնացել են առաջադրանքներ`,
        [Locale.En]: `The user still has tasks`,
        [Locale.Pt]: 'O usuário ainda tem tarefas',
        [Locale.Ge]: `მომხმარებელს დარჩა ამოცანები`,
    },
    userHasActiveEpisodes: {
        [Locale.Ru]: `У пользователя есть активные эпизоды`,
        [Locale.Am]: `Օգտատերն ունի ակտիվ էպիզոդներ`,
        [Locale.En]: `The user has active episodes`,
        [Locale.Pt]: 'O usuário tem episódios ativos',
        [Locale.Ge]: `მომხმარებელს აქვს აქტიური ეპიზოდები`,
    },
    singleExecutorAndNotAuthor: {
        [Locale.Ru]: `Является единственным исполнителем и не является автором`,
        [Locale.Am]: `Հանդիսանում է միակ կատարողը և չի հանդիսանում հեղինակ`,
        [Locale.En]: `Is the only executor and not the author`,
        [Locale.Pt]: 'É o único executor e não o autor',
        [Locale.Ge]: `არის ერთადერთი შემსრულებელი და არა ავტორი`,
    },
    executorAndNotAuthor: {
        [Locale.Ru]: `Является исполнителем и не является автором`,
        [Locale.Am]: `Հանդիսանում է կատարող և չի հանդիսանում հեղինակ`,
        [Locale.En]: `The executor and not the author`,
        [Locale.Pt]: 'O executor e não o autor',
        [Locale.Ge]: `არის შემსრულებელი და არა ავტორი`,
    },
    multipleExecutors: {
        [Locale.Ru]: `Есть другие исполнители`,
        [Locale.Am]: `Կան այլ կատարողներ`,
        [Locale.En]: `There are other executors`,
        [Locale.Pt]: 'Existem outros executores',
        [Locale.Ge]: `არსებობს სხვა შემსრულებლები`,
    },
    singleExecutorAndAuthor: {
        [Locale.Ru]: `Является единственным исполнителем и автором`,
        [Locale.Am]: `Հանդիսանում է միակ կատարողը և հեղինակը`,
        [Locale.En]: `Is the only executor and the author`,
        [Locale.Pt]: 'É o único executor e autor',
        [Locale.Ge]: `არის ერთადერთი შემსრულებელი და ავტორი`,
    },
    executorAndAuthor: {
        [Locale.Ru]: `Является исполнителем и автором`,
        [Locale.Am]: `Հանդիսանում է կատարող և հեղինակ`,
        [Locale.En]: `The executor and the author`,
        [Locale.Pt]: 'O executor e o autor',
        [Locale.Ge]: `არის ერთადერთი შემსრულებელი და ავტორი`,
    },
    chooseNewExecutor: {
        [Locale.Ru]: `Выберите пользователя, который станет исполнителем`,
        [Locale.Am]: `Ընտրեք օգտատիրոջը, ով կդառնա կատարող`,
        [Locale.En]: `Select the user who will become the executor`,
        [Locale.Pt]: 'Selecione o usuário que se tornará o executor',
        [Locale.Ge]: `აირჩიეთ მომხმარებელი, რომელიც გახდება შემსრულებელი`,
    },
    needToChooseUser: {
        [Locale.Ru]: `Необходимо выбрать пользователя.`,
        [Locale.Am]: `Անհրաժեշտ է ընտրել օգտատիրոջը։`,
        [Locale.En]: `You need to select a user.`,
        [Locale.Pt]: 'Você precisa selecionar um usuário.',
        [Locale.Ge]: `საჭიროა მომხმარებლის არჩევა.`,
    },
    userWillBeChosenAutomatically: {
        [Locale.Ru]: `Пользователь будет выбран автоматически.`,
        [Locale.Am]: `Օգտատերը կընտրվի ավտոմատ։`,
        [Locale.En]: `The user will be selected automatically.`,
        [Locale.Pt]: 'O usuário será selecionado automaticamente.',
        [Locale.Ge]: `მომხმარებელი ავტომატურად იქნება არჩეული.`,
    },
    warning: {
        [Locale.Ru]: `Внимание`,
        [Locale.Am]: `Ուշադրություն`,
        [Locale.En]: `Warning`,
        [Locale.Pt]: `Aviso`,
        [Locale.Ge]: `Warning`,
    },
    userHasSubscriptions: {
        [Locale.Ru]: `У пользователя остались подписки`,
        [Locale.Am]: `Օգտատիրոջ մոտ մնացել են բաժանորդագրություններ`,
        [Locale.En]: `The user still has subscriptions`,
        [Locale.Pt]: 'O usuário ainda tem assinaturas',
        [Locale.Ge]: `მომხმარებელს ჯერ კიდევ აქვს გამოწერები`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
